import { ENV } from '~/common/enums/enums';
import { SeoPayload } from '~/common/types/types';

const seoPayload: SeoPayload = {
  title: 'seo.faq.title',
  description: 'seo.faq.description',
  siteUrl: ENV.APP.URL,
};

export { seoPayload };
